/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AddTrackedUsernameRequest,
  ApiEnvelopeBoolean,
  ApiEnvelopeTrackedUsernameDto,
  ApiEnvelopeTrackedUsernameListResponse
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type minecraftUsernameTrackerListResponse200 = {
  data: ApiEnvelopeTrackedUsernameListResponse
  status: 200
}

export type minecraftUsernameTrackerListResponse400 = {
  data: ApiEnvelopeTrackedUsernameListResponse
  status: 400
}

export type minecraftUsernameTrackerListResponseSuccess = (minecraftUsernameTrackerListResponse200) & {
  headers: Headers;
};
export type minecraftUsernameTrackerListResponseError = (minecraftUsernameTrackerListResponse400) & {
  headers: Headers;
};

export type minecraftUsernameTrackerListResponse = (minecraftUsernameTrackerListResponseSuccess | minecraftUsernameTrackerListResponseError)

export const getMinecraftUsernameTrackerListUrl = () => {




  return `/api/username-tracker`
}

export const useMinecraftUsernameTrackerListHook = (): ( options?: RequestInit) => Promise<minecraftUsernameTrackerListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getMinecraftUsernameTrackerListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type minecraftUsernameTrackerAddResponse200 = {
  data: ApiEnvelopeTrackedUsernameDto
  status: 200
}

export type minecraftUsernameTrackerAddResponse400 = {
  data: ApiEnvelopeTrackedUsernameDto
  status: 400
}

export type minecraftUsernameTrackerAddResponseSuccess = (minecraftUsernameTrackerAddResponse200) & {
  headers: Headers;
};
export type minecraftUsernameTrackerAddResponseError = (minecraftUsernameTrackerAddResponse400) & {
  headers: Headers;
};

export type minecraftUsernameTrackerAddResponse = (minecraftUsernameTrackerAddResponseSuccess | minecraftUsernameTrackerAddResponseError)

export const getMinecraftUsernameTrackerAddUrl = () => {




  return `/api/username-tracker`
}

export const useMinecraftUsernameTrackerAddHook = (): (addTrackedUsernameRequest?: AddTrackedUsernameRequest, options?: RequestInit) => Promise<minecraftUsernameTrackerAddResponse> => {

      const customFetcher = useSfetchMutator();
      return (addTrackedUsernameRequest?: AddTrackedUsernameRequest, options?: RequestInit) => {

        return customFetcher(getMinecraftUsernameTrackerAddUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addTrackedUsernameRequest)
  }
);
      }
  }


export type minecraftUsernameTrackerRemoveResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type minecraftUsernameTrackerRemoveResponse400 = {
  data: ApiEnvelopeBoolean
  status: 400
}

export type minecraftUsernameTrackerRemoveResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type minecraftUsernameTrackerRemoveResponseSuccess = (minecraftUsernameTrackerRemoveResponse200) & {
  headers: Headers;
};
export type minecraftUsernameTrackerRemoveResponseError = (minecraftUsernameTrackerRemoveResponse400 | minecraftUsernameTrackerRemoveResponse404) & {
  headers: Headers;
};

export type minecraftUsernameTrackerRemoveResponse = (minecraftUsernameTrackerRemoveResponseSuccess | minecraftUsernameTrackerRemoveResponseError)

export const getMinecraftUsernameTrackerRemoveUrl = (id: string,) => {




  return `/api/username-tracker/${id}`
}

export const useMinecraftUsernameTrackerRemoveHook = (): (id: string, options?: RequestInit) => Promise<minecraftUsernameTrackerRemoveResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getMinecraftUsernameTrackerRemoveUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


